import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import GalleryLightbox from "../components/GalleryLightbox";
import {
  SakuraFlower,
  CherryBranchImg,
  JapaneseBadge,
} from "../components/SakuraDecorations";

export default function OmMigPage() {
  const educationItems = [
    {
      year: "2025",
      text: (
        <>
          kursus i ”
          <Link
            to="/ondt-i-kaeben"
            className="text-[#d74814] underline font-medium hover:text-[#593427]"
          >
            Manuel behandling af kæbeproblemer
          </Link>
          ”
        </>
      ),
    },
    {
      year: "2025",
      text: "Kursus i ”Akupunktur mod myggestik – Naturlig lindring af kløe og hævelse”",
    },
    {
      year: "2023",
      text: (
        <>
          Klinisk uddannelse i Japan –{" "}
          <a
            href="https://www.morioka-hari-kyuu-massagein.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#d74814] underline font-medium hover:text-[#593427]"
          >
            Morioka harikyuu massage klinik
          </a>
        </>
      ),
    },
    {
      year: "2023",
      text: (
        <>
          Klinisk uddannelse i Japan –{" "}
          <a
            href="http://www.hari-kyuu.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#d74814] underline font-medium hover:text-[#593427]"
          >
            Harikyu Odawara akupunktur klinik
          </a>
          , og Hayakawa Akupunktur klinik
        </>
      ),
    },
    {
      year: "2021",
      text: "Sikkerheds kursus i at forebygge, erkende og håndtere skader på lungerne efter nåleakupunktur på brystkassen",
    },
    {
      year: "2021",
      text: (
        <>
          Certificeret Kostvejleder fra At Work Skolen – målrettet rådgivning til{" "}
          <Link
            to="/vaegtregulering"
            className="text-[#d74814] underline font-medium hover:text-[#593427]"
          >
            vægtregulering
          </Link>
        </>
      ),
    },
    {
      year: "2020",
      text: (
        <>
          Afgangsprojekt ”
          <Link
            to="/stress"
            className="text-[#d74814] underline font-medium hover:text-[#593427]"
          >
            Behandling af stressramte med Keiraku Chiryo
          </Link>
          ”
        </>
      ),
    },
    {
      year: "2016-2020",
      text: (
        <>
          B.C, Uddannelse som akupunktør fra Akupunktur Akademiet (klassisk{" "}
          <Link
            to="/akupunktur"
            className="text-[#d74814] underline font-medium hover:text-[#593427]"
          >
            akupunktur
          </Link>
          )
        </>
      ),
    },
    {
      year: "2015",
      text: (
        <>
          Kursus som Nada akupunktør (
          <Link
            to="/oere-akupunktur"
            className="text-[#d74814] underline font-medium hover:text-[#593427]"
          >
            øreakupunktur
          </Link>
          )
        </>
      ),
    },
    {
      year: "2005",
      text: "Uddannelse som Social og sundhedsassistent i Århus",
    },
    {
      year: "2004",
      text: "Uddannelse som social og sundhedshjælper i Århus",
    },
    {
      year: "1996-1997",
      text: "Social Worker, Social Worker Registration Certificate, The Social Welfare Promotion and Examination Center, Japan (Godkendt i Danmark, det samlede uddannelsesforløb i niveau svarer til en dansk professions bacheloruddannelse som socialrådgiver)",
    },
    {
      year: "1988-1996",
      text: "Ansættelse som socialrådgiver på Shonan Tyuou Hospital i Japan",
    },
    {
      year: "1984-1988",
      text: "Bachelor of Welfare Psychology, Tohoku Fukushi University i Japan",
    },
    {
      year: "1984",
      text: "Japansk studentereksamen",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Om Mayumi Kita Thiele | Kita Akupunktur</title>
        <meta
          name="description"
          content="Mød RAB-godkendt akupunktør Mayumi Kita Thiele i Risskov. Læs om min japanske baggrund, erfaring og nænsomme tilgang til din behandling."
        />
        <meta property="og:title" content="Om Mayumi Kita Thiele | Kita Akupunktur" />
        <meta
          property="og:description"
          content="Mød RAB-godkendt akupunktør Mayumi Kita Thiele i Risskov. Læs om min japanske baggrund, erfaring og nænsomme tilgang til din behandling."
        />
        <link rel="canonical" href="https://kita-akupunktur.dk/om-mig/" />
      </Helmet>

      {/* Page Header */}
      <section className="bg-gradient-to-b from-[#FFFAF7] via-[#FFE0CF]/30 to-[#FFFAF7] py-14 lg:py-20 border-b border-[#ffe0cf]/80 relative z-20 overflow-hidden">
        {/* Botanical Cherry Branch Accent from /design-elements/ (cherry-4.png) */}
        <div className="absolute -top-6 -right-6 w-56 sm:w-72 opacity-50 pointer-events-none z-10">
          <CherryBranchImg index={4} flip={true} className="w-full h-auto" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20">
          <div className="inline-flex items-center space-x-2 px-3 py-1 rounded-full glass-pill mb-3 text-xs font-semibold text-[#d74814]">
            <SakuraFlower className="w-3.5 h-3.5 text-[#d74814]" />
            <span>MAYUMI KITA THIELE • KITA AKUPUNKTUR</span>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif text-[#593427]">Om mig</h1>
          <p className="text-base sm:text-lg text-[#593427]/80 mt-2 max-w-2xl">
            Mayumi Kita Thiele – RAB-registreret akupunktør med speciale i japansk akupunktur og kostvejledning.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start mb-20">
          {/* Left / Profile text */}
          <div className="lg:col-span-7 space-y-6 text-[#593427]/90 leading-relaxed text-base sm:text-lg">
            <div className="glass-sakura p-5 rounded-2xl border border-[#ffe0cf] mb-4">
              <p className="font-medium text-[#593427]">
                Jeg hedder Mayumi Kita Thiele og driver klinikken{" "}
                <Link to="/" className="text-[#d74814] font-semibold underline decoration-[#ffe0cf] hover:text-[#b3360b] hover:decoration-[#d74814] transition-colors">
                  Kita Akupunktur
                </Link>
                . Jeg er født i Japan, har boet i Danmark i de sidste 28 år og er dansk gift.
              </p>
            </div>

            <p>
              Jeg er medlem af{" "}
              <a
                href="https://aku-net.dk/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#d74814] font-semibold underline decoration-[#ffe0cf] hover:text-[#593427]"
              >
                Praktiserende Akupunktører
              </a>{" "}
              og{" "}
              <Link
                to="/priser"
                className="text-[#d74814] font-semibold underline decoration-[#ffe0cf] hover:text-[#593427]"
              >
                RAB-registreret behandler
              </Link>
              , hvilket giver dig mulighed for tilskud fra Sygeforsikring “danmark”.
            </p>

            <p>
              Jeg er også{" "}
              <a
                href="https://stps.dk/da/registrering/naaleakupunktur-paa-brystkassen/liste-over-naaleakupunktoerer/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#d74814] font-semibold underline decoration-[#ffe0cf] hover:text-[#593427]"
              >
                registreret nåleakupunktør ved patientsikkerhedsstyrelsen
              </a>
              .
            </p>

            <p>
              Jeg er uddannet TCM (traditionel kinesisk medicin){" "}
              <Link
                to="/akupunktur"
                className="text-[#d74814] font-semibold underline decoration-[#ffe0cf] hover:text-[#593427]"
              >
                akupunktur
              </Link>{" "}
              fra Akupunktur Akademiet.
            </p>

            <p>
              Mit speciale er indenfor{" "}
              <Link to="/japansk-akupunktur" className="text-[#d74814] font-semibold underline decoration-[#ffe0cf] hover:text-[#593427]">
                japansk akupunktur
              </Link>
              . Jeg har lavet mit B.C. afgangsprojekt ”
              <Link to="/stress" className="text-[#d74814] font-semibold underline decoration-[#ffe0cf] hover:text-[#593427]">
                Behandling af stressramte med Keiraku Chiryo
              </Link>
              ”, som er en traditionel Japansk akupunktur metode.
            </p>

            <p>
              Jeg er desuden certificeret{" "}
              <a
                href="http://www.atwork.dk/uddannelser/kostvejleder/specialer/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#d74814] font-semibold underline decoration-[#ffe0cf] hover:text-[#593427]"
              >
                kostvejleder fra At Work Skolen
              </a>
              , og jeg tilbyder kombineret kostvejledning og akupunktur til{" "}
              <Link to="/vaegtregulering" className="text-[#d74814] font-semibold underline decoration-[#ffe0cf] hover:text-[#593427]">
                vægtregulering
              </Link>
              . Dvs. jeg tilbyder målrettet og faglig rådgivning samt vejledning til overvægtige, der ønsker at tabe sig.
            </p>

            <p>
              Jeg er også certificeret NADA-udøver fra{" "}
              <a
                href="https://nada-danmark.dk/nada/om-nada-bjaelken/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#d74814] font-semibold underline decoration-[#ffe0cf] hover:text-[#593427]"
              >
                NADA Danmark
              </a>{" "}
              og tilbyder{" "}
              <Link to="/oere-akupunktur" className="text-[#d74814] font-semibold underline decoration-[#ffe0cf] hover:text-[#593427]">
                øreakupunktur
              </Link>
              .
            </p>

            <div className="pt-2 grid grid-cols-1 sm:grid-cols-2 gap-3">
              <JapaneseBadge
                label="FØDT & OPVOKSET I JAPAN"
                desc="Autentisk japansk Meridianterapi"
                variant="hanko"
              />
              <Link to="/priser" className="block group">
                <JapaneseBadge
                  label="RAB-REGISTRERET"
                  desc="Giver mulighed for Sygeforsikring tilskud (Se priser)"
                  variant="sakura"
                />
              </Link>
            </div>
          </div>

          {/* Right / Photo & credentials */}
          <div className="lg:col-span-5 space-y-6">
            <div className="relative">
              <div className="absolute -top-3 -right-3 w-28 h-28 enso-circle border-2 border-[#d74814]/20 pointer-events-none" />
              <div className="glass-card p-4 rounded-3xl overflow-hidden shadow-xl border border-[#ffe0cf]">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/71339d65-a05d-4c02-a540-2260acdfc245/kita-akupunktoer-risskov-klinik.jpg"
                  alt="Mayumi Kita Thiele – RAB-registreret akupunktør i klinikken i Risskov"
                  className="w-full h-auto rounded-2xl object-cover object-right"
                  width="450"
                  height="450"
                />
                <div className="p-4 text-center">
                  <h2 className="text-xl font-serif text-[#593427] font-bold">Mayumi Kita Thiele</h2>
                  <p className="text-sm text-[#d74814] font-semibold">RAB-registreret Akupunktør & Kostvejleder</p>
                </div>
              </div>
            </div>

            {/* Quick credentials box */}
            <div className="glass-card p-6 rounded-2xl border border-[#ffe0cf] space-y-3">
              <div className="flex items-center space-x-3 text-sm text-[#593427]">
                <div className="w-8 h-8 rounded-full bg-[#e1ef9f] text-[#593427] flex items-center justify-center shrink-0">
                  <i className="fa-solid fa-certificate text-xs" aria-hidden="true" />
                </div>
                <div>
                  <span className="font-semibold block text-[#593427]">RAB Godkendt</span>
                  <span className="text-xs text-[#593427]/70">Opfylder alle krav til uddannelse og efteruddannelse</span>
                </div>
              </div>

              <div className="flex items-center space-x-3 text-sm text-[#593427] pt-2 border-t border-[#ffe0cf]">
                <div className="w-8 h-8 rounded-full bg-[#ffe0cf] text-[#d74814] flex items-center justify-center shrink-0">
                  <i className="fa-solid fa-spa text-xs" aria-hidden="true" />
                </div>
                <div>
                  <span className="font-semibold block text-[#593427]">Keiraku Chiryo Speciale</span>
                  <span className="text-xs text-[#593427]/70">Traditionel japansk meridianterapi med skånsom nåleteknik</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Uddannelsesbaggrund liste */}
        <div className="mb-20">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-2xl sm:text-3xl font-serif text-[#593427]">
              Uddannelse & Baggrund
            </h2>
            <p className="text-[#593427]/80 text-sm sm:text-base mt-2">
              Løbende videreuddannelse i Danmark, Japan og internationalt for at sikre højeste faglige kvalitet.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3.5 items-start">
            <div className="flex flex-col gap-3.5">
              {educationItems
                .filter((_, idx) => idx % 2 === 0)
                .map((item, idx) => (
                  <div
                    key={`col1-${idx}`}
                    className="p-4 rounded-xl bg-white/90 border border-[#ffe0cf] flex items-start space-x-3.5 shadow-2xs h-fit"
                  >
                    <span className="px-2.5 py-0.5 rounded-full bg-[#ffe0cf]/70 text-[#593427] text-xs font-bold shrink-0 border border-[#ffe0cf]">
                      {item.year}
                    </span>
                    <div className="text-sm text-[#593427]/90 leading-relaxed font-medium">
                      {item.text}
                    </div>
                  </div>
                ))}
            </div>
            <div className="flex flex-col gap-3.5">
              {educationItems
                .filter((_, idx) => idx % 2 === 1)
                .map((item, idx) => (
                  <div
                    key={`col2-${idx}`}
                    className="p-4 rounded-xl bg-white/90 border border-[#ffe0cf] flex items-start space-x-3.5 shadow-2xs h-fit"
                  >
                    <span className="px-2.5 py-0.5 rounded-full bg-[#ffe0cf]/70 text-[#593427] text-xs font-bold shrink-0 border border-[#ffe0cf]">
                      {item.year}
                    </span>
                    <div className="text-sm text-[#593427]/90 leading-relaxed font-medium">
                      {item.text}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="glass-sakura p-8 sm:p-12 rounded-3xl border border-[#ffe0cf] text-center max-w-3xl mx-auto">
          <SakuraFlower className="w-8 h-8 text-[#d74814] mx-auto mb-3" />
          <h2 className="text-2xl sm:text-3xl font-serif text-[#593427] mb-3">
            Klar til at opleve japansk akupunktur?
          </h2>
          <p className="text-[#593427]/80 text-sm sm:text-base mb-6 max-w-xl mx-auto">
            Book en tid eller kontakt mig for en uforpligtende snak om, hvordan akupunktur og kostvejledning kan hjælpe dig.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <a
              href="https://kita-akupunktur.klikbop.dk/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-[#d74814] text-white text-sm font-semibold hover:bg-[#593427] transition-colors shadow-sm"
            >
              <i className="fa-solid fa-calendar-check mr-2" aria-hidden="true" />
              Book tid online
            </a>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-white text-[#593427] border border-[#ffe0cf] text-sm font-semibold hover:bg-[#ffe0cf]/50 transition-colors"
            >
              Kontakt mig
            </Link>
            <Link
              to="/priser"
              className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-white text-[#593427] border border-[#ffe0cf] text-sm font-semibold hover:bg-[#ffe0cf]/50 transition-colors"
            >
              Se priser & tilskud
            </Link>
            <Link
              to="/faq"
              className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-white text-[#593427] border border-[#ffe0cf] text-sm font-semibold hover:bg-[#ffe0cf]/50 transition-colors"
            >
              Ofte stillede spørgsmål (FAQ)
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}